export default __webpack_public_path__ + "static/screen_erp_3-f1a9f2b6964e9f4dbaaed6ae7d22921e.png";